/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { closelightbox } from "../../util/Functions";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const SpaceBlock = (props) => {
  const [zPos, setZPos] = useState(45);
  const [reason, setReason] = useState(-1);
  const [comment, setComment] = useState("");
  const [reasonDesc, setReasonDesc] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [catalogReason, setCatalogReason] = useState([]);
  const history = useHistory();

  useEffect(() => {
    getCatalog()
  }, []);

  const getCatalog = async () => {
    props.changeLoader(true);
    let data = {
      catalog: {
        id: 'cancelation.type',
        filters: [{ type: 'block'}],
      },
    };
    let catalog = await API.service( "getCatalog", data, props.pos, props.changeAlert, props.changeLoader, history);
    props.changeLoader(false);
    setCatalogReason(catalog.data.data.catalog);
  };

  const hasField = (field) => {
    return props?.["config"]?.fields?.in?.indexOf(field) > -1;
  };
  
  const onSelectReason = (e) => {
    setReason(Number(e.target.value));
    let desc = "";
    let cats = props.content.catalog;
    for (let i = 0; i < cats.length; i++) {
      if (cats[i]["k"] == e.target.value) {
        desc = cats[i]["v"];
      }
    }
    if(e.target.value == "64"){
      desc = "Legacy revenant"
    }
    setReasonDesc(desc);
    if (e.target.value > 0) {setDisabled(false)} else {setDisabled(true)}
  };

  const send = async () => {
    let data = {
      customerUuid: props.customerUuid, //TWO_FACTOR_AUTH
      spaceUuid: props.content.spaceUuid,
      action: "block",
      reasonCode: reason,
    };

    if (data.action == "block") {
      data["reasonDesc"] = reasonDesc;
      data["comment"] = comment;
    }
    props.changeLoader(true);
		setZPos(-1)
    closelightbox();

    let request = await API.service( "spaceBlockUnblock", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200 && request.data.data.response == "OK") {
      await props.changeReload();
      props.setCancelDisabled(true);
      props.setRadioData(null);
      props.changeAlert(true, "success", "Datos actualizados con éxito");
      closelightbox();
    }

    props.changeLoader(false);
		setZPos(45)
  };

  const changeValue = (e) => {
    setComment(e.target.value);
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(disabled)}>
				<DialogTitle style={{marginBottom: "0"}} >
					Bloquear Cuenta
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>

				<DialogContent>
					<Grid container spacing={2} sx={{ marginTop: "10px" }} >
						<Grid item xs={12} >
							Se bloquearán las siguientes cuentas:       
							<hr style={{margin: "6px 0 14px 0"}}/>
						</Grid>

						<Grid item xs={12}>							
							{props.content && props.content.account_number ? `Cuenta ${props.content.account_number}` : ""}
						</Grid>
						<Grid item xs={12}><hr style={{margin: "6px 0 14px 0"}}/></Grid>
						<Grid item xs={6}>
							<TextField  
								label="Motivo" value={reason} select onChange={onSelectReason.bind(this)} size="small" fullWidth >
									<MenuItem value={"-1"}>Seleccione</MenuItem>
									{catalogReason?.map((item, index) => {
                    return (item.k === '64' && hasField("legacy") && <MenuItem key={`option-${index}`} value={item.k}>{item.v}</MenuItem> )||
                    (item.k !== '64' && <MenuItem key={`option-${index}`} value={item.k}>{item.v}</MenuItem>)
                  })}                  
							</TextField>              
						</Grid> 
						<Grid item xs={6}>
							<TextField  
								label="Comentarios" value={comment} onChange={changeValue.bind(this)} size="small" fullWidth />
						</Grid>         
					</Grid>
				</DialogContent>

				<DialogActions>
					<Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>
					<Button disabled={disabled} variant="contained" onClick={send.bind(this)} >Aceptar</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog>
  );
};

export default SpaceBlock;
